import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const appRequestsRoute: InvariantJiraRoute = {
	name: 'marketplace-app-requests',
	path: '/jira/marketplace/manage/app-requests',
};
